// DEPENDENCIES
import React, { useState, useEffect } from 'react';
// COMPONENTS
import MUIDataTable from "mui-datatables";
// ICONS
import { HiCheck } from 'react-icons/hi';
import { CgClose } from 'react-icons/cg';
// CUSTOM COMPONENTS
import Section from '../../components/Section';
import ContentBlock from '../../components/ContentBlock';
import CustomBlock from '../../components/CustomBlock';
import ContentHeader from '../../components/ContentHeader';
import Button from '../../components/Button';
import LoadingScreen from '../../components/LoadingScreen';
// SERVICES AND HELPERS
import * as Helper from '../../helpers/helper';
import * as SalesToolService from '../../services/salestool.service';
import moment from 'moment';

const SalesToolListingPage = (props) => {
    const isSalesCoach = Helper.IsLoggedInUserSalesCoach();
    const role = Helper.IsUserLoggedIn();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);

    useEffect(() => {
        setLoading(true);
        SalesToolService.GetAll().then(res => {
            setData(res);
            setLoading(false);
        }).catch(ex => {
            setLoading(false);
        });
    }, []);

    const columns = [
        {
            name: 'id',
            label: 'Action',
            options: {
                filter: false,
                sort: false,
                print: false,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <CustomBlock className="content-container--actions pl-0 mt-0" style={{justifyContent:"flex-start"}}>
                            {
                                isSalesCoach == true || role == 'SuperAdmin' ?
                                    <Button
                                        text="Edit"
                                        to={"/sales-tool/" + data[dataIndex].id}
                                        target="_blank"
                                        size="xs"
                                        className="primary--bg ml-0"
                                    /> : <></>

                            }
                            <Button
                                text="View"
                                to={"/sales-tool-details/" + data[dataIndex].id}
                                target="_blank"
                                size="xs"
                                className="primary--bg"
                            />
                        </CustomBlock>
                    );
                }
            }
        },
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                sort: false
            }
        },
        {
            name: "availableOn",
            label: "Available On",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {data[dataIndex].availableOn ? moment(data[dataIndex].availableOn).format("MMMM Do YYYY") : "--"}
                        </>
                    );
                }
            }
        },
        {
            name: "availableUntil",
            label: "Available Until",
            options: {
                filter: true,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {data[dataIndex].availableUntil ? moment(data[dataIndex].availableUntil).format("MMMM Do YYYY") : "--"}
                        </>
                    );
                }
            }
        },
        {
            name: "isActive",
            label: "Active?",
            options: {
                filter: false,
                sort: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {data[dataIndex].isActive ? <HiCheck size={25} className="success--clr" /> : <CgClose size={25} className="danger--clr" />}
                        </>
                    );
                }
            }
        }
    ];

    return (
        <>
            {
                loading ?
                    <LoadingScreen /> :
                    <CustomBlock className="main-container light--bg">
                        <Section>
                            <CustomBlock className="content-container--card-style">
                                <ContentHeader
                                    title="Sales Tools"
                                    headerSize="mdlg"
                                    primaryButtonText={isSalesCoach == true ? "Add" : ""}
                                    primaryButtonTo="/add-new-sales-tool"
                                    primaryButtonBackgroundColor="success--bg"
                                />
                                <Section removeContainer>
                                    <ContentBlock>
                                        <MUIDataTable
                                            data={data}
                                            columns={columns}
                                            options={{
                                                selectableRows: "none"
                                            }}
                                        />
                                    </ContentBlock>
                                </Section>
                            </CustomBlock>
                        </Section>
                    </CustomBlock>
            }
        </>
    );
}

export default SalesToolListingPage;